import { render, staticRenderFns } from "./AudienceLabel.vue?vue&type=template&id=4af0b023&lang=pug"
import script from "./AudienceLabel.vue?vue&type=script&lang=js"
export * from "./AudienceLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports